import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { EmailLabelingConfigAssignmentComponent } from './email-labeling-config-assignment.component';

export interface EmailLabelingConfigUserDialogData {
  namespace: string;
  userId: string;
  /** Optional base URL for "View Details" link (e.g. BCC uses account/location/.../administration/email-labeling-settings). */
  viewDetailsUrlBase?: string;
}

@Component({
  selector: 'email-labeling-config-user-dialog',
  standalone: true,
  imports: [MatDialogContent, EmailLabelingConfigAssignmentComponent],
  template: `
    <mat-dialog-content>
      <email-labeling-config-assignment
        [namespace]="data.namespace"
        [userId]="data.userId"
        [viewDetailsUrlBase]="data.viewDetailsUrlBase ?? '/email-labeling-settings'"
        (configurationApplied)="dialogRef.close()"
        (cancelled)="dialogRef.close()"
        (navigateToConfig)="onNavigateToConfig()"
      />
    </mat-dialog-content>
  `,
})
export class EmailLabelingConfigUserDialogComponent {
  readonly data = inject<EmailLabelingConfigUserDialogData>(MAT_DIALOG_DATA);
  readonly dialogRef = inject(MatDialogRef<EmailLabelingConfigUserDialogComponent>);
  private readonly router = inject(Router);

  onNavigateToConfig(): void {
    this.dialogRef.close();
    this.router.navigateByUrl(this.data.viewDetailsUrlBase ?? '/email-labeling-settings');
  }
}
